import {arrayOf, bool, objectOf, shape, string} from 'prop-types';

export const moduleShape = {
  moduleName: string,
  title: string,
  route: string,
  showNav: bool,
  hideHeader: bool,
  paramList: arrayOf(string),
};

export const pluginShape = {
  modules: arrayOf(shape(moduleShape)),
  name: string,
  description: string,
  author: shape({
    name: string,
    email: string,
    url: string,
  }),
  source: string,
  current: string,
  versions: arrayOf(string),
};

export const pluginRegistryShape = {
  plugins: objectOf(shape(pluginShape)),
};

